import * as Yup from 'yup';
import { cleanMask } from 'Utils/MaskUtils';
import i18n from 'i18n';

// Espelha FaturamentoForm.schema (mesmos campos fiscais, mesmas obrigatoriedades)
// e acrescenta o representante legal, que a emissão da nota por SPE exige.
//
// Diferença deliberada: as mensagens saem do i18n em vez da const local `msg` do
// FaturamentoForm — aquele arquivo tem a string em português cravada no código, o
// que viola a regra de i18n do projeto e não foi corrigido aqui para não misturar
// refactor com feature nova.
// Mensagens passadas como FUNÇÃO, não como string: o schema é avaliado uma vez na
// carga do módulo, então resolver i18n.t() aqui cravaria o idioma daquele momento
// (e devolveria a chave crua se o i18n ainda não tivesse inicializado). Yup aceita
// message como função e a chama na hora de validar.
const required = () => i18n.t('faturamento:spe.validation.required');
const emailMessage = () => i18n.t('faturamento:spe.validation.email');

// Valida só o comprimento: o dígito verificador de CNPJ/CPF é conferido pelo
// backend contra a Receita, e reimplementar o cálculo aqui criaria uma segunda
// fonte de verdade para a mesma regra.
const digitsLength = (length: number, message: () => string) =>
  Yup.string()
    .required(required)
    .nullable()
    .test(
      'digits-length',
      message,
      (value) => !value || cleanMask(value).length === length
    );

const schema = Yup.object().shape({
  companyName: Yup.string().required(required).nullable(),
  cnpj: digitsLength(14, () => i18n.t('faturamento:spe.validation.cnpj')),
  phone: Yup.string().required(required).nullable(),
  email: Yup.string().email(emailMessage).required(required).nullable(),
  ownerName: Yup.string().required(required).nullable(),
  // Site e endereço (logradouro) são os dois únicos campos opcionais do cadastro,
  // por decisão de produto. O logradouro é derivável do CEP.
  site: Yup.string().nullable(),
  zip: digitsLength(8, () => i18n.t('faturamento:spe.validation.zip')),
  streetAddress: Yup.string().nullable(),
  number: Yup.number()
    .typeError(() => i18n.t('faturamento:spe.validation.number'))
    .required(required)
    .nullable(),
  district: Yup.string().required(required).nullable(),
  city: Yup.string().required(required).nullable(),
  state: Yup.string().required(required).nullable(),
  complement: Yup.string().nullable(),
  legalRepresentative: Yup.object().shape({
    name: Yup.string().required(required).nullable(),
    cpf: digitsLength(11, () => i18n.t('faturamento:spe.validation.cpf')),
    role: Yup.string().required(required).nullable(),
    email: Yup.string().email(emailMessage).required(required).nullable(),
    phone: Yup.string().required(required).nullable(),
  }),
});

export default schema;
